/**
 * LocalSendCell — planned send time in the recipient country's local timezone.
 * Mirrors the "Planned send" (Danish) column so you can see which local hours
 * you are scheduling for. Shows (+1) / (-1) when the local day differs.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { describeCountryLocalSend } from '@/utils/country-timezone';

interface LocalSendCellProps {
  executeAfter?: string | null;
  countryKey: string;
}

const Placeholder: FC = () => (
  <div className="min-w-0 truncate text-xs tabular-nums text-muted-foreground">
    <span className="opacity-50">—</span>
  </div>
);

export const LocalSendCell: FC<LocalSendCellProps> = ({ executeAfter, countryKey }) => {
  const local = describeCountryLocalSend(executeAfter, countryKey);
  if (!local) return <Placeholder />;

  return (
    <div
      className="flex min-w-0 items-baseline gap-1 text-xs tabular-nums text-muted-foreground"
      title={`${local.full} · ${local.tzLabel}`}
    >
      <span className="truncate text-foreground">{local.time}</span>
      {local.dayDelta !== 0 && (
        <span className="shrink-0 text-[10px] leading-none text-primary/80">
          {local.dayDelta > 0 ? '(+1)' : '(−1)'}
        </span>
      )}
    </div>
  );
};
